import { styled } from "@mui/material";

import { Stack } from "@/Components/v2/atoms/Stack";

interface FullScreenCenteredProps {
  children: React.ReactNode;
}

const FullScreenCentered: React.FC<FullScreenCenteredProps> = ({ children }) => {
  return (
    <StyledPageContainer>
      <Stack
        direction="column"
        spacing={2}
        justifyContent={"center"}
        alignItems={"center"}
        height={"100vh"}
      >
        {children}
      </Stack>
    </StyledPageContainer>
  );
};

export default FullScreenCentered;

const StyledPageContainer = styled("div")(({ theme }) => {
  return {
    backgroundColor: theme.palette.background.paper,
    margin: "0",
    padding: "0",
    width: "100%",
  };
});
